import React, { useEffect } from "react";
import validator from 'validator';
import ImageUploader from "../imageUploader";

const languageOptions = [
    { value: 'english', label: 'English' },
    { value: 'spanish', label: 'Spanish' },
    { value: 'french', label: 'French' },
    { value: 'german', label: 'German' },
    { value: 'italian', label: 'Italian' },
    { value: 'portuguese', label: 'Portuguese' },
    { value: 'chinese', label: 'Mandarin Chinese' },
    { value: 'russian', label: 'Russian' },
    { value: 'korean', label: 'Korean' },
    { value: 'japanese', label: 'Japanese' },
    { value: 'arabic', label: 'Arabic' },
    { value: 'hebrew', label: 'Hebrew' },
]

const TourGuideForm = ({ me, locations, formSubmitFunc, tourguide, imageUploadFunc }) => {
    const [name, setName] = React.useState("");
    const [nameError, setNameError] = React.useState(null);
    const [avatarUrl, setAvatarUrl] = React.useState("");
    const [bio, setBio] = React.useState("");
    const [bioError, setBioError] = React.useState(null);
    const [location, setLocation] = React.useState("");
    const [locationError, setLocationError] = React.useState(null);
    const [languages, setLanguages] = React.useState([]);
    const [languagesError, setLanguagesError] = React.useState(null);
    const [website, setWebsite] = React.useState("");
    const [websiteError, setWebsiteError] = React.useState(null);
    const [facebook, setFacebook] = React.useState("");
    const [facebookError, setFacebookError] = React.useState(null);
    const [instagram, setInstagram] = React.useState("");
    const [instagramError, setInstagramError] = React.useState(null);
    const [twitter, setTwitter] = React.useState("");
    const [twitterError, setTwitterError] = React.useState(null);
    const [linkedin, setLinkedin] = React.useState("");
    const [linkedinError, setLinkedinError] = React.useState(null);
    const [tiktok, setTiktok] = React.useState("");
    const [tiktokError, setTiktokError] = React.useState(null);

    useEffect(() => {
        if (tourguide) {
            setName(tourguide.name || "")
            setBio(tourguide.bio || "")
            setLocation(tourguide.location_id || "")
            setFacebook(tourguide.facebook || "")
            setInstagram(tourguide.instagram || "")
            setTwitter(tourguide.twitter || "")
            setLinkedin(tourguide.linkedin || "")
            setTiktok(tourguide.tiktok || "")
            setAvatarUrl(tourguide.avatar_url || "")
            setWebsite(tourguide.webpage || "")
            setLanguages((tourguide.languages && tourguide.languages.split(",")) || [])
        }
    }, [tourguide])

    const validateAndSubmit = (e) => {
        e.preventDefault();

        // Clear all errors
        setNameError(null)
        setBioError(null)
        setLocationError(null)
        setFacebookError(null)
        setInstagramError(null)
        setTwitterError(null)
        setLinkedinError(null)
        setTiktokError(null)
        setWebsiteError(null)
        setLanguagesError(null)

        let errors = false;

        if (name === "") {
            setNameError('Please enter your name or business name')
            errors = true;
        }

        if (bio === "") {
            setBioError('Tell visitors about yourself and your tours')
            errors = true;
        }

        if (location === "") {
            setLocationError('Please select your location')
            errors = true;
        }

        if (languages.length < 1) {
            setLanguagesError('Please select at least one language')
            errors = true;
        }

        if (website && !validator.isURL(website)) {
            setWebsiteError('Please enter a valid URL')
            errors = true;
        }

        if (facebook && !validator.isURL(facebook)) {
            setFacebookError('Please enter a valid URL')
            errors = true;
        }

        if (instagram && !validator.isURL(instagram)) {
            setInstagramError('Please enter a valid URL')
            errors = true;
        }

        if (tiktok && !validator.isURL(tiktok)) {
            setTiktokError('Please enter a valid URL')
            errors = true;
        }

        if (linkedin && !validator.isURL(linkedin)) {
            setLinkedinError('Please enter a valid URL')
            errors = true;
        }

        if (twitter && !validator.isURL(twitter)) {
            setTwitterError('Please enter a valid URL')
            errors = true;
        }

        if (!twitter && !facebook && !instagram && !website && !linkedin && !tiktok) {
            setWebsiteError('Please add at least one way for visitors to contact you')
            errors = true;
        }

        if (errors) return;

        formSubmitFunc({
            name,
            avatar_url: avatarUrl,
            languages: languages.join(","),
            user_id: me.id,
            email: me.email,
            location_id: location,
            bio,
            webpage: website,
            facebook,
            instagram,
            twitter,
            linkedin,
            tiktok
        })
    }

    const handleLanguageChange = (language, checked) => {
        if (checked) {
            if (!languages.includes(language)) {
                setLanguages([...languages, language]);
            }
        } else {
            setLanguages(languages.filter((l) => l !== language));
        }
    };

    return (
        <form onSubmit={validateAndSubmit} className="tour-form">
            <div className="form-section">
                <label className="form-section-title">Profile Photo</label>
                <ImageUploader imageUrls={[avatarUrl]} imageUploadFunc={imageUploadFunc} />
            </div>

            <div className="form-section">
                <label htmlFor="name" className="form-label">Guide Name</label>
                <input
                    id="name"
                    className={`form-input ${nameError ? 'error' : ''}`}
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    placeholder="Your name or business name"
                />
                <small className="text-muted">This is how visitors will identify you</small>
                {nameError && <span className="error-text">{nameError}</span>}
            </div>

            <div className="form-section">
                <label htmlFor="selectLocation" className="form-label">Location</label>
                <select
                    id="selectLocation"
                    className={`form-input ${locationError ? 'error' : ''}`}
                    value={location || ''}
                    onChange={(e) => setLocation(e.target.value)}
                >
                    <option value="" disabled>Select your location</option>
                    {locations.map((loc) => (
                        <option key={loc.id} value={loc.id}>
                            {loc.flag} {loc.city}, {loc.country}
                        </option>
                    ))}
                </select>
                <small className="text-muted">
                    Don't see your location? <a href="mailto:admin@castlerock.ai">Contact us</a>
                </small>
                {locationError && <span className="error-text">{locationError}</span>}
            </div>

            <div className="form-section">
                <label className="form-label">Languages Spoken</label>
                <div className={`checkbox-grid ${languagesError ? 'error' : ''}`}>
                    {languageOptions.map((language, index) => (
                        <div key={index} className="form-check">
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id={`language-${language.value}`}
                                value={language.value}
                                onChange={(e) => handleLanguageChange(language.value, e.target.checked)}
                                checked={languages.includes(language.value)}
                            />
                            <label className="form-check-label" htmlFor={`language-${language.value}`}>
                                {language.label}
                            </label>
                        </div>
                    ))}
                </div>
                {languagesError && <span className="error-text">{languagesError}</span>}
            </div>

            <div className="form-section">
                <label htmlFor="bio" className="form-label">Bio</label>
                <textarea
                    id="bio"
                    rows="4"
                    className={`form-input textarea ${bioError ? 'error' : ''}`}
                    value={bio}
                    onChange={(e) => setBio(e.target.value)}
                    placeholder="Tell visitors about yourself, your experience, and what makes your tours special..."
                />
                {bioError && <span className="error-text">{bioError}</span>}
            </div>

            <hr className="my-4" />

            <h3 className="mb-3">Contact Information</h3>
            <p className="text-muted mb-4">Add at least one way for visitors to reach you. This information will be visible on your public profile.</p>

            <div className="form-section">
                <label htmlFor="selectWebpage" className="form-label">
                    <i className="bi bi-globe me-2"></i>Website
                </label>
                <input
                    id="selectWebpage"
                    className={`form-input ${websiteError ? 'error' : ''}`}
                    placeholder="https://yourwebsite.com"
                    value={website}
                    onChange={(e) => setWebsite(e.target.value)}
                />
                {websiteError && <span className="error-text">{websiteError}</span>}
            </div>

            <div className="form-row">
                <div className="form-section half">
                    <label htmlFor="selectFacebook" className="form-label">
                        <i className="bi bi-facebook me-2"></i>Facebook
                    </label>
                    <input
                        id="selectFacebook"
                        className={`form-input ${facebookError ? 'error' : ''}`}
                        value={facebook}
                        placeholder="https://facebook.com/yourprofile"
                        onChange={(e) => setFacebook(e.target.value)}
                    />
                    {facebookError && <span className="error-text">{facebookError}</span>}
                </div>

                <div className="form-section half">
                    <label htmlFor="selectInstagram" className="form-label">
                        <i className="bi bi-instagram me-2"></i>Instagram
                    </label>
                    <input
                        id="selectInstagram"
                        className={`form-input ${instagramError ? 'error' : ''}`}
                        value={instagram}
                        placeholder="https://instagram.com/yourprofile"
                        onChange={(e) => setInstagram(e.target.value)}
                    />
                    {instagramError && <span className="error-text">{instagramError}</span>}
                </div>
            </div>

            <div className="form-row">
                <div className="form-section half">
                    <label htmlFor="selectTwitter" className="form-label">
                        <i className="bi bi-twitter-x me-2"></i>X / Twitter
                    </label>
                    <input
                        id="selectTwitter"
                        className={`form-input ${twitterError ? 'error' : ''}`}
                        placeholder="https://x.com/yourprofile"
                        value={twitter}
                        onChange={(e) => setTwitter(e.target.value)}
                    />
                    {twitterError && <span className="error-text">{twitterError}</span>}
                </div>

                <div className="form-section half">
                    <label htmlFor="selectLinkedin" className="form-label">
                        <i className="bi bi-linkedin me-2"></i>LinkedIn
                    </label>
                    <input
                        id="selectLinkedin"
                        className={`form-input ${linkedinError ? 'error' : ''}`}
                        placeholder="https://linkedin.com/in/yourprofile"
                        value={linkedin}
                        onChange={(e) => setLinkedin(e.target.value)}
                    />
                    {linkedinError && <span className="error-text">{linkedinError}</span>}
                </div>
            </div>

            <div className="form-section">
                <label htmlFor="tiktok" className="form-label">
                    <i className="bi bi-tiktok me-2"></i>TikTok
                </label>
                <input
                    id="tiktok"
                    className={`form-input ${tiktokError ? 'error' : ''}`}
                    value={tiktok}
                    placeholder="https://tiktok.com/@yourprofile"
                    onChange={(e) => setTiktok(e.target.value)}
                />
                {tiktokError && <span className="error-text">{tiktokError}</span>}
            </div>

            <div className="form-actions">
                <button type="submit" className="btn-primary">Save Profile</button>
            </div>
        </form>
    )
}

export default TourGuideForm;
